var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.45c2.01 0 3.65-1.64 3.65-3.65S12.01 3.15 10 3.15 6.35 4.79 6.35 6.8s1.64 3.65 3.65 3.65Zm0-6.05c1.32 0 2.4 1.08 2.4 2.4S11.32 9.2 10 9.2 7.6 8.12 7.6 6.8 8.68 4.4 10 4.4Zm7.49 10.89c-1.61-2.74-4.41-4.38-7.49-4.38s-5.89 1.64-7.5 4.38c-.19.32-.19.73 0 1.05.19.33.53.52.9.52h13.2c.38 0 .72-.2.9-.52.19-.32.18-.73 0-1.05Zm-13.72.32c1.4-2.17 3.71-3.45 6.23-3.45s4.82 1.28 6.23 3.45H3.77Z",
    fill: "current"
  })));
};
export default SvgUser;